export interface Result<T, E> {
  isOk: () => boolean;
  isErr: () => boolean;

  unwrap: () => T;
  unwrapErr: () => E;
  unwrapOr: (d: T) => T;

  map: <U>(fn: (item: T) => U) => Result<U, E>;
  mapErr: <F>(fn: (err: E) => F) => Result<T, F>;
}

export const Ok = <T>(item: T): Result<T, never> => {
  return {
    isOk: () => true,
    isErr: () => false,

    unwrap: () => item,
    unwrapErr: () => {
      throw new Error('can not unwrap error on Ok');
    },
    unwrapOr: () => item,

    map: (fn) => Ok(fn(item)),
    mapErr: (fn) => Ok(item),
  };
};

export const Err = <T, E>(err: E): Result<T, E> => {
  return {
    isOk: () => false,
    isErr: () => true,

    unwrap: () => {
      throw new Error('can not unwrap on Err');
    },
    unwrapErr: () => err,
    unwrapOr: (d: T) => d,

    map: (fn) => Err(err),
    mapErr: (fn) => Err(fn(err)),
  };
};

export class MetricsEngineError extends Error {
  public constructor(m: string) {
    super(m);

    // Set the prototype explicitly. Any subclass will have to manually set the prototype as well.
    // tslint:disable-next-line: max-line-length
    // See: https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, MetricsEngineError.prototype);
  }
}
